import axios from "axios";
import { Checkbox, Select } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const EmployeeInfo = ({
  setShow,
  data,
  setShowErrorModal,
  setShowSuccessModal,
  setErr,
  setRoute,
  setRefetch,
  refetch,
}) => {
  console.log(data);
  const [error, setError] = useState("");
  const [amount, setAmount] = useState(0);
  const [payFull, setPayFull] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalNetAmount, setTotalNetAmount] = useState(0);
  const [totalTaxAmount, setTotalTaxAmount] = useState(0);
  const [totalDelivery, setTotalDelivery] = useState(0);
  const [totalSubTotal, setTotalSubTotal] = useState(0);
  const [pendingPartialAmount, setPendingPartialAmount] = useState(0);
  const [pendingAmount, setPendingAmount] = useState(0);
  const [paidAmount, setPaidAmount] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const token = useSelector((state) => state.token);

  useEffect(() => {
    let tempTotalAmount = 0;
    let tempTotalDiscount = 0;
    let tempTotalNetAmount = 0;
    let tempTotalTaxAmount = 0;
    let tempTotalDelivery = 0;
    let tempTotalSubTotal = 0;
    let tempPendingPartialAmount = 0;
    let tempPendingAmount = 0;
    let PaidAmount = 0;

    const orderdata = data;

    // Calculate total paid Amount
    orderdata?.invOrderPayments?.forEach((item) => {
      PaidAmount += Number(item?.paidAmount || 0);
    });

    PaidAmount = roundToTwoDecimals(PaidAmount);
    console.log("Total Paid Amount:", PaidAmount);

    const result =
      orderdata?.invOrderItems?.map((item) => {
        const totalAmount = Number(item?.totalAmount || 0);
        const quantity = Number(item?.actualUnits || 0);
        const deliveredUnit =
          item?.invorderitemstatuses?.find((status) => status?.isCurrent)
            ?.partialQtyDelivered || 0;

        // Calculate per unit price
        const perUnitPrice = quantity > 0 ? totalAmount / quantity : 0;

        // Calculate total amount based on delivered quantity
        const deliveredAmount = deliveredUnit * perUnitPrice;

        return {
          id: item?.invproductId,
          quantity,
          deliveredUnit,
          status: item?.status,
          totalAmount: roundToTwoDecimals(totalAmount),
          deliveredAmount: roundToTwoDecimals(deliveredAmount), // Amount according to delivered quantity
        };
      }) || [];

    // Calculate total sum of amounts
    const totalOverallAmount = result.reduce(
      (sum, item) => roundToTwoDecimals(sum + item.totalAmount),
      0
    );
    const totalDeliveredAmount = result.reduce(
      (sum, item) => roundToTwoDecimals(sum + item.deliveredAmount),
      0
    );
    tempPendingPartialAmount = totalDeliveredAmount;

    console.log("Total Overall Amount:", totalOverallAmount);
    console.log("Total Delivered Amount:", totalDeliveredAmount);

    orderdata?.invOrderItems?.forEach((item) => {
      tempTotalAmount += Number(item?.totalAmount || 0);
      tempTotalDiscount += Number(item?.discountApplied || 0);
      tempTotalNetAmount += Number(item?.netAmount || 0);
      tempTotalTaxAmount += Number(item?.taxApplied || 0);
      tempTotalDelivery += Number(item?.calcDeliveryFee || 0);

      const getMatchedRate = orderdata?.invAlteredPrices?.find((rate) => {
        if (item?.invadvancepriceId) {
          return rate?.invadvancepriceId === item?.invadvancepriceId;
        }
        return rate?.invproductId === item?.invproductId;
      });

      // Determine the applicable price
      const unitPrice = getMatchedRate?.newPrice
        ? getMatchedRate.newPrice
        : item?.invadvanceprice
        ? item?.invadvanceprice?.price
        : Number(item?.prodBasePrice || 0);

      console.log(unitPrice);

      // Calculate SubTotal
      const SubTotal = Number(item?.actualUnits || 0) * unitPrice;
      tempTotalSubTotal += SubTotal; // Add to the running total
    });

    tempTotalAmount = roundToTwoDecimals(tempTotalAmount);
    console.log("Total Amount:", tempTotalAmount);

    // Update tempPendingAmount using PaidAmount
    tempPendingAmount = roundToTwoDecimals(tempTotalAmount - PaidAmount);

    console.log("Pending Amount:", tempPendingAmount);

    setTotalAmount(tempTotalAmount);
    setTotalDiscount(roundToTwoDecimals(tempTotalDiscount));
    setTotalNetAmount(roundToTwoDecimals(tempTotalNetAmount));
    setTotalTaxAmount(roundToTwoDecimals(tempTotalTaxAmount));
    setTotalDelivery(roundToTwoDecimals(tempTotalDelivery));
    setTotalSubTotal(roundToTwoDecimals(tempTotalSubTotal));
    setPendingPartialAmount(tempPendingPartialAmount);
    setPendingAmount(tempPendingAmount);
    setPaidAmount(PaidAmount); // Update state with the new value
  }, [data]);

  const roundToTwoDecimals = (num) => Math.round(num * 100) / 100;

  // useEffect(() => {
  //   let tempTotalAmount = 0;
  //   let tempTotalDiscount = 0;
  //   let tempTotalNetAmount = 0;
  //   let tempTotalTaxAmount = 0;
  //   let tempTotalDelivery = 0;
  //   let tempTotalSubTotal = 0;
  //   let tempPendingPartialAmount = 0;
  //   let tempPendingAmount = 0;

  //   const orderdata = data;

  //   const currentPayment = data?.invOrderPayments?.find(
  //     (item) => item?.isCurrent
  //   );
  //   console.log(currentPayment);

  //   const result =
  //     orderdata?.invOrderItems?.map((item) => {
  //       const totalAmount = item?.totalAmount || 0;
  //       const quantity = item?.actualUnits || 0;
  //       const deliveredUnit =
  //         item?.invorderitemstatuses?.find((status) => status?.isCurrent)
  //           ?.partialQtyDelivered || 0;

  //       // Calculate per unit price
  //       const perUnitPrice = quantity > 0 ? totalAmount / quantity : 0;

  //       // Calculate total amount based on delivered quantity
  //       const deliveredAmount = deliveredUnit * perUnitPrice;

  //       return {
  //         id: item?.invproductId,
  //         quantity,
  //         deliveredUnit,
  //         status: item?.status,
  //         totalAmount,
  //         deliveredAmount, // Amount according to delivered quantity
  //       };
  //     }) || [];

  //   // Calculate total sum of amounts
  //   const totalOverallAmount = result.reduce(
  //     (sum, item) => sum + item.totalAmount,
  //     0
  //   );
  //   const totalDeliveredAmount = result.reduce(
  //     (sum, item) => sum + item.deliveredAmount,
  //     0
  //   );
  //   tempPendingPartialAmount = totalDeliveredAmount;

  //   console.log("Total Overall Amount:", totalOverallAmount);
  //   console.log("Total Delivered Amount:", totalDeliveredAmount);

  //   orderdata?.invOrderItems?.forEach((item) => {
  //     tempTotalAmount += Number(item?.totalAmount || 0);
  //     tempTotalDiscount += Number(item?.discountApplied || 0);
  //     tempTotalNetAmount += Number(item?.netAmount || 0);
  //     tempTotalTaxAmount += Number(item?.taxApplied || 0);
  //     tempTotalDelivery += Number(item?.calcDeliveryFee || 0);

  //     const getMatchedRate = orderdata?.invAlteredPrices?.find((rate) => {
  //       if (item?.invadvancepriceId) {
  //         return rate?.invadvancepriceId === item?.invadvancepriceId;
  //       }
  //       return rate?.invproductId === item?.invproductId;
  //     });

  //     // Determine the applicable price
  //     const unitPrice = getMatchedRate?.newPrice
  //       ? getMatchedRate.newPrice
  //       : item?.invadvanceprice
  //       ? item?.invadvanceprice?.price
  //       : Number(item?.prodBasePrice || 0);

  //     console.log(unitPrice);

  //     // Calculate SubTotal
  //     const SubTotal = Number(item?.actualUnits || 0) * unitPrice;
  //     tempTotalSubTotal += SubTotal; // Add to the running total

  //     tempPendingAmount = tempTotalAmount - (currentPayment?.paidAmount || 0);
  //   });

  //   setTotalAmount(tempTotalAmount);
  //   setTotalDiscount(tempTotalDiscount);
  //   setTotalNetAmount(tempTotalNetAmount);
  //   setTotalTaxAmount(tempTotalTaxAmount);
  //   setTotalDelivery(tempTotalDelivery);
  //   setTotalSubTotal(tempTotalSubTotal);
  //   setPendingPartialAmount(tempPendingPartialAmount);
  //   setPendingAmount(tempPendingAmount);
  // }, [data]);

  const MakePayment = () => {
    const body = {
      paymentMethod: selectedOption, //Allowed: [cash, bank, sap-wallet]
      paymentType: ![
        "partially-in-progress",
        "buyer-partial-accepted",
        "partially-shipped",
        "partially-delivered",
        "partially-recieved",
      ].includes(data?.invOrder?.finalStatus)
        ? "paid"
        : payFull || pendingAmount < pendingPartialAmount
        ? "paid"
        : "partially-paid",
      totalAmount: ![
        "partially-in-progress",
        "buyer-partial-accepted",
        "partially-shipped",
        "partially-delivered",
        "partially-recieved",
      ].includes(data?.invOrder?.finalStatus)
        ? pendingAmount
        : payFull || pendingAmount < pendingPartialAmount
        ? pendingAmount
        : pendingPartialAmount,
    };
    console.log(body);
    // return
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/v1/inv-order-payment?invOrderId=${data?.invOrder?.id}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        setRefetch(!refetch);
        setShow(false);
        //  setErr("Payment done sucessfullt")
        //  setRoute("/Inventory-Vendor-Orders")
        //  setShowSuccessModal(true)
      })
      .catch((err) => {
        setErr(err?.response?.data?.message);
        setShowErrorModal(true);
      });
  };

  const methods = [
    {
      label: "Bank",
      value: "bank",
    },
    {
      label: "SAP-Wallet",
      value: "sap-wallet",
    },
  ];

  return (
    <>
      <div
        className={`w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center z-30 `}
      >
        <div className="relative p-4 w-full max-w-md max-h-full">
          <div className="relative bg-white rounded-lg shadow ">
            <div className="flex items-center justify-between p-4 md:p-4 border-b rounded-t ">
              <h3 className="text-lg font-semibold text-gray-900 ">Pay Now</h3>
              <button
                onClick={() => {
                  setShow(false);
                }}
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center  "
                data-modal-toggle="select-modal"
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>

            <div className="flex justify-center">
              <div className="w-[90%] mt-3">
                <p className="text-gray-900 text-center font-semibold text-[0.95rem] py-3">
                  Do you want to proceed with payment
                  {[
                    "partially-in-progress",
                    "buyer-partial-accepted",
                    "partially-shipped",
                    "partially-delivered",
                    "partially-recieved",
                  ].includes(data?.invOrder?.finalStatus)
                    ? ""
                    : ` $${pendingAmount}`}
                  ?
                </p>

                <div className="w-full gap-3 ">
                  {[
                    "partially-in-progress",
                    "buyer-partial-accepted",
                    "partially-shipped",
                    "partially-delivered",
                    "partially-recieved",
                  ].includes(data?.invOrder?.finalStatus) && (
                    <>
                    <input
                      type="text"
                      placeholder=""
                      onChange={(e) => {
                        const value = e.target.value.replace(/^\$/, ""); // Remove any leading dollar sign
                        if (payFull) {
                          setPendingAmount(value);
                        } else {
                          setPendingPartialAmount(value);
                        }
                        setAmount(value)
                      }}
                      // onChange={(e) => {
                      //   const value = e.target.value.replace(/^\$/, ""); // Remove any leading dollar sign
                      //   const numericValue = parseFloat(value) || 0; // Convert to number
              
                      //   if (payFull) {
                      //     if (numericValue > pendingAmount) {
                      //       setPendingAmount(numericValue);
                      //       setError("Amount cannot exceed pending amount.");
                      //     } else {
                      //       setError("");
                      //       setPendingAmount(numericValue);
                      //     }
                      //   } else {
                      //     if (numericValue > pendingPartialAmount) {
                      //       setPendingPartialAmount(numericValue);
                      //       setError("Amount cannot exceed pending partial amount.");
                      //     } else {
                      //       setError("");
                      //       setPendingPartialAmount(numericValue);
                      //     }
                      //   }
                      // }}
                      value={`$${
                        payFull || pendingAmount < pendingPartialAmount
                          ? pendingAmount
                          : pendingPartialAmount
                      }`}
                      className="lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                    />
                     {error && <p className="text-red-500 text-sm">{error}</p>}
                    </>
                    
                  )}

                  {[
                    "partially-in-progress",
                    "buyer-partial-accepted",
                    "partially-shipped",
                    "partially-delivered",
                    "partially-recieved",
                  ].includes(data?.invOrder?.finalStatus) && (
                    <Checkbox
                      className={`checkk2`}
                      // checked={verify}
                      onClick={(e) => setPayFull(e.target.checked)}
                    >
                      Pay full order amount
                    </Checkbox>
                  )}

                  <h1 className="text-gray-700 text-[0.97rem] py-3 font-semibold">
                    Payment Method
                  </h1>
                  <div className="flex gap-6  items-center">
                    {methods?.map((item, index) => (
                      <div className="mb-2 flex items-center" key={index}>
                        <input
                          type="radio"
                          value={item?.value}
                          className="mr-2 h-4 w-4 cursor-pointer text-green-500 focus:ring-green-400 focus:ring-opacity-50 rounded-full custom-radio"
                          checked={selectedOption === item?.value}
                          onChange={(e) => {
                            setSelectedOption(e.target.value);
                          }}
                        />
                        <label className="cursor-pointer text-sm inline-flex items-center ml-2">
                          {item?.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex justify-center pb-6 mt-4">
                  <button
                    onClick={() => {
                      setShow(false);
                    }}
                    className="cursor-pointer rounded-md pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[45%]"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={()=>{
                      // if(amount > pendingAmount){
                      //   setError("Amount cannot exceed pending amount.");
                      //   return
                      // }
                      MakePayment()
                    }}
                    className="ml-5 cursor-pointer rounded-md pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-primary w-[45%]"
                  >
                    Pay
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeInfo;
